import { Component, Input, ViewChild, OnChanges, AfterViewInit, AfterViewChecked } from '@angular/core';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { MenuController, NavController } from 'ionic-angular';
import { ModalController, NavParams, Platform } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { datos } from '../../providers/datos';
import { Login } from '../login/login';
import * as io from 'socket.io-client';
import { html } from '../html/html';
import { lista } from '../lista/lista';
import { ActionSheetController } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
declare var SMS: any;
declare var swal: any;
declare var window: any;
declare var cordova: any;
declare var jquery: any;



@Component({
  selector: 'notificaciones',
  templateUrl: 'notificaciones.html'
})

export class notificaciones {
  socket: any;
  activo = "ESCOJER";
  imgMenu = "assets/images/menu/v3/";
  contador = 0;
  pagina = {
    headerTitle: "GPS-TRACK ",
    subtitle: "",
    items: [
    ]

  }
  constructor(
    private datos: datos,
    private modalCtrl: ModalController,
    public navCtrl: NavController,
    private menu: MenuController,
    public actionSheetCtrl: ActionSheetController,
    private alertCtrl: AlertController
  )
   {
    this.getVehiculos();
  }




  conectar() {
    console.log("Conectar..." + this.datos.url_soket);
    this.socket = io(this.datos.url_soket);
    this.login2().subscribe(dato => {
      console.log("login2");
      console.log(dato);
    });

  }


  openUrl(url) {
    console.log(url);
    window.location.href = url;
  }


  login2() {
    console.log("login...");
    let observable = new Observable(observer => {
      this.socket.on('connect', () => {
        // this.socket.emit('login', this.datos.login.id);
        this.socket.emit('login', 0);
// 
      });
    })

    return observable;
  }



  enviaSMS(mensaje?, llama?) {
    let boton = "Listo"

    if (llama == 1) { boton = "Llamar" }
    // <a href="+34666666666?body=hola%20mundo">Mandar SMS</a>
    let number = this.datos.activo.numero_limpio; /* iOS: ensure number is actually a string */
    let message = mensaje;

console.log("SMS:"+mensaje);
    //CONFIGURATION
    let options = {
      replaceLineBreaks: false, // true to replace \n by a new line, false by default
      android: {
        intent: 'INTENT'  // send SMS with the native android SMS messaging
        //intent: '' // send SMS without opening any other app
      }
    };

    var success = function () {
  console.log("OK");

      swal({
        title: "LISTO",
        text: "<<" + mensaje + ">>Listo!",
        icon: "success",
        confirmButtonColor: "red",
        buttons: {
          // cancel: "cancel!",     
          defeat: {
            text: boton,
            value: "ok"
          },
        },
      })
        .then((value) => {

          switch (value) {

            case "ok":

              if (llama == 1) {
                setTimeout(() => {
                  this.openUrl(this.datos.activo.numero);
                }, 2000);

              }
              //this.carrito();


              break;
            default:
              console.log("cancelado");
          }
        });


    };
    var error = function (e) { alert('Message FailQQed:' + e); };

    try {
      SMS.sendSMS(number, mensaje, options, success, error);
    } catch (error) {

      console.log("ERROR" + error);

    }







  }

  ionViewDidEnter() {

    let data = JSON.parse(this.datos.getLocalStorage('login_espe'));
    console.log(data);
    if (data) {
      this.datos.login = data;
      this.datos.pedido.usuario = data.id;
    }


    this.menu.swipeEnable(false);
    if (!this.datos.login.login) {
      // var _hora = moment(hor
      //if (this.contador<1){
      this.datos.Toast("Login !", 500);

      setTimeout(() => {
        this.navCtrl.push(Login);
        this.contador++;
      }, 500);
      // }


      // else {
      //   this.navCtrl.pop();
      //  this.contador=0;
      // }

    }



    else {

      this.conectar();
      this.getNotificacion().subscribe(resp => {
        let notificacion = JSON.parse(String(resp));

        // this.datos.notificacion(notificacion.titulo);
        // this.openHtmlNot(notificacion.lat);

        this.datos.activo.lat=notificacion.lat;
        this.datos.activo.lng=notificacion.lng;
        

        setTimeout(() => {

        }, 3000);



      }
      );

    }

  }


  openHtmlNot(data) {




    let item = {
      titulo: 'Detalles',
      html: data
    }


    console.log("modal");
    let modal = this.modalCtrl.create(html, { "item": item }, { cssClass: "" });
    //let modal = this.modalCtrl.create(html,{"item":item },{cssClass: ""});

    // modal.onDidDismiss(data => {

    //   if (data.dato) {

    //      }
    //      console.log(JSON.stringify(data));
    //    });
    modal.present();


  }
  openHtml(item) {




    item = {
      titulo: 'Detalles',
      html: item.html
    }

    console.log("modal");
    let modal = this.modalCtrl.create(html, { "item": item }, { cssClass: "" });
    //let modal = this.modalCtrl.create(html,{"item":item },{cssClass: ""});

    // modal.onDidDismiss(data => {

    //   if (data.dato) {

    //      }
    //      console.log(JSON.stringify(data));
    //    });
    modal.present();



  }





  getNotificacion() {
    let observable = new Observable(observer => {
      this.socket.on('notificacion', (data) => {
        observer.next(data);
      });
    });
    return observable;
  }


  iniciar_soket() {
    console.log("iniciar");
    this.getNotificacion().subscribe(notificacion => {
      //  this.datos.notificacion(notificacion);

    });



  }
  openMapa() {
    this.navCtrl.push(lista, { "items": [] })
  }




  enviarDesbloqueo(item?) {
    swal(
      {
        title: "DESBLOQUEO",
        text: "Desea enviar señal de reactivar energía ?",
        buttons: {
          cancel: "Cancelar",
          defeat: {
            text: "SÍ",
            value: "ok"
          },
        },
      })
      .then((value) => {
        switch (value) {

          case "ok":

            this.enviaSMS(this.datos.comandos.enciendeCorriente+this.datos.activo.clave);

            break;
          //  fin del ok del primero modal 
          default:
            console.log("cancelado");
        }
      });

  }



  enviarBloqueo(item?) {
    swal(
      {
        title: "BLOQUEO",
        text: "Desea enviar señal de corte de energía ?",
        buttons: {
          cancel: "Cancelar",
          defeat: {
            text: "SÍ",
            value: "ok"
          },
        },
      })
      .then((value) => {
        switch (value) {

          case "ok":


            this.enviaSMS(this.datos.comandos.enciendeCorriente+this.datos.activo.clave);


            break;
          //  fin del ok del primero modal 
          default:
            console.log("cancelado");
        }
      });

  }


  enviarEscucha(item?) {
    swal(
      {
        title: "ESCUCHAR",
        text: "Escuchar micrófono remoto ?",
        buttons: {
          cancel: "Cancelar!",
          defeat: {
            text: "SI",
            value: "ok"
          },
        },
      })
      .then((value) => {
        switch (value) {

          case "ok":
            this.enviaSMS(this.datos.comandos.modoMonitor + this.datos.activo.clave, 1);

            break;
          //  fin del ok del primero modal 
          default:
            console.log("cancelado");
        }
      });

  }



  ubicarLlamada() {
    swal(
      {
        title: "Llamada",
        // icon: "warning",
        text: "Llamar al para que retorne su ubicación ?",
        buttons: {
          cancel: "Cancelar!",
          defeat: {
            text: "SI",
            value: "ok"
          },
        },
      })
      .then((value) => {
        switch (value) {

          case "ok":
            this.openUrl(this.datos.activo.numero);
            break;
          default:
            console.log("cancelado");
        }
      });

  }



  modoTracker() {
    swal(
      {
        title: "Tracker",
        text: "Cambiar a modo tracker ?",
        // icon: "warning",
        buttons: {
          cancel: "Cancelar!",
          defeat: {
            text: "SI",
            value: "ok"
          },
        },
      })
      .then((value) => {
        switch (value) {

          case "ok":
            this.enviaSMS(this.datos.comandos.modoTracker + this.datos.activo.clave, 0);

            break;
          //  fin del ok del primero modal 
          default:
            console.log("cancelado");
        }
      });

  }


  activarLimiteVelocidad() {
    swal(
      {
        title: "Velocidad",
        text: "Activar límite de velocidad ?",
        // icon: "warning",
        buttons: {
          cancel: "Cancelar",
          defeat: {
            text: "SÍ",
            value: "ok"
          },
        },
      })
      .then((value) => {
        switch (value) {

          case "ok":

          this.detalleVelocidad();
            // this.enviaSMS(this.datos.comandos.desactivaVelocidad + this.datos.activo.clave);

            break;
          //  fin del ok del primero modal 
          default:
            console.log("cancelado");
        }
      });

  }

  desactivarLimiteVelocidad() {
    swal(
      {
        title: "Velocidad",
        text: "Desactivar límite de velocidad ?",
        // icon: "warning",
        buttons: {
          cancel: "Cancelar",
          defeat: {
            text: "SÍ",
            value: "ok"
          },
        },
      })
      .then((value) => {
        switch (value) {

          case "ok":
            this.enviaSMS(this.datos.comandos.desactivaVelocidad + this.datos.activo.clave);

            break;
          //  fin del ok del primero modal 
          default:
            console.log("cancelado");
        }
      });

  }



  detalleVelocidad() {
    let alert = this.alertCtrl.create({
      title: 'VELOCIDAD',
      inputs: [
        {
          name: 'velocidad',
          placeholder: 'velocidad'
        }
  
      ],
      buttons: [
  
        {
          text: 'ACEPTAR',
          handler: data => {
            if (data.velocidad) {

              if(parseInt(data.velocidad)){
                this.enviaSMS(this.datos.comandos.activaVelocidad + this.datos.activo.clave+' '+data.velocidad);

              }

              else{

              this.datos.Toast("Dato no válido !", 2000);

              }

              // this.datos.pedido.direccion.detalle= data.Referencia;
              // this.datos.pedido.direccion.text="GPS";
              // console.log("object");
            } else {
              // invalid login
              // this.detalleGPS();
              return false;
            }
          }
        }
      ]
    });
    alert.present();
  }
  

  activarModoParqueo(){
    swal(
      {
        title: "Parqueo",
        text: "Activar modo parqueo ?",
        // icon: "warning",
        buttons: {
          cancel: "Cancelar",
          defeat: {
            text: "SÍ",
            value: "ok"
          },
        },
      })
      .then((value) => {
        switch (value) {

          case "ok":
            this.enviaSMS(this.datos.comandos.activaAlarmaEstacionamiento + this.datos.activo.clave);

            break;
          //  fin del ok del primero modal 
          default:
            console.log("cancelado");
        }
      });
  }

 desactivarModoParqueo(){
  swal(
    {
      title: "Parqueo",
      text: "Desactivar modo parqueo ?",
      // icon: "warning",
      buttons: {
        cancel: "Cancelar",
        defeat: {
          text: "SÍ",
          value: "ok"
        },
      },
    })
    .then((value) => {
      switch (value) {

        case "ok":
          this.enviaSMS(this.datos.comandos.desactivaAlarmaEstacionamiento + this.datos.activo.clave);

          break;
        //  fin del ok del primero modal 
        default:
          console.log("cancelado");
      }
    });
  }

  cambiarVehiculo() {

    let buttons = [];

    for (let index = 0; index < this.datos.vehiculos.length; index++) {
      buttons.push(
        {
          text: this.datos.vehiculos[index].nombre,
          role: 'destructive',
          icon: 'car',
          handler: () => {
            this.activo = this.datos.vehiculos[index].nombre;
            this.datos.activo.id = parseInt(this.datos.vehiculos[index].id_equipo);

            // this.datos.pedido.pago.id="0";
            console.log('Destructive clicked');
          }
        }




      );

    }

  
  

    const actionSheet = this.actionSheetCtrl.create({
      title: 'SELECCIONAR VEHÍCULO:',
      buttons: buttons

    });
    actionSheet.present();



  }


  getVehiculos(){
   this.datos.getVehiculos().subscribe(data => {
      this.datos.vehiculos= data.data;
    }); 
  }

}



// WEBPACK FOOTER //
// ./src/pages/notificaciones/notificaciones.ts